import React, { useState } from "react";
//import * as React from 'react';
import classNames from "classnames";
import "./style.css";
import Header from "components/Header/Header.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody";
import CustomFooter from "components/CustomFooter/CustomFooter.js";
import JobApplicationForm from "components/Forms/Jobs/JobForm";
import Button from "components/CustomButtons/Button";
import { Link } from "react-router-dom";
//export default function VideoEditor() {
const MarketingCoordinator = () => {
  const [isFormVisible, setIsFormVisible] = useState(false);
  //setIsFormVisible(false);

  const toggleFormVisibility = () => {
    setIsFormVisible(!isFormVisible);
    console.log("Form is: ");
    console.log(isFormVisible);
  };

  return (
    <div className="pageDiv">
      <Header
        brand="WeVett Realty"
        links={<HeaderLinks dropdownHoverColor="primary" />}
        fixed
        color="transparent"
        changeColorOnScroll={{
          height: 80,
          color: "secondary",
        }}
      />
      <div className={classNames("main-content", "job-page")}>
        <div className={classNames("section", "fullwidth")}>
          <Card className={classNames("card-split", "title-card")}>
            <CardBody className={classNames("card-body", "boxed")}>
              <h2>Marketing Coordinator</h2>
            </CardBody>
          </Card>
        </div>
        <div className={classNames("section", "boxed")}>
          <div className={classNames("wrapper-btn", "float-right")}>
            <Button
              type="button"
              color="secondary"
              onClick={toggleFormVisibility}
              className={isFormVisible ? "muted-btn" : ""}
            >
              {isFormVisible ? "Hide Form" : "APPLY NOW"}
            </Button>
            <div className="form-wrapper">
              {isFormVisible ? (
                <JobApplicationForm position="Marketing Coordinator" />
              ) : null}
            </div>
          </div>

          <div className={classNames("posting-details", "left-aligned")}>
            <div>
              <h3>Available Position:</h3>
              <p>Marketing Coordinator</p>
            </div>
            <div>
              <h3>Position:</h3>
              <p>
                Part-Time (with potential to move to full-time in the future)
              </p>
            </div>
            <div>
              <h3>Location:</h3>
              <p>Wichita, KS (position is eligible for remote work)</p>
            </div>
            <div>
              <h3>Compensation:</h3>
              <p>
                Hourly Rate $22-$28 per hour depending on experience and
                skillset
              </p>
            </div>
            <div>
              <h3>The Company:</h3>
              <p>
                WeVett is a fast-growing, military-focused family of businesses
                looking to add a Marketing Coordinator to our team.
                <br />
                <br />
                <strong>Our Mission:</strong> To bring consistency to the PCS
                process, making military moves easier.
                <br />
                <br />
                <strong>Our 20-Year Client Vision:</strong> Our goal is that our
                clients have a paid for or nearly paid for home by the time they
                retire, reducing the financial stress of transitioning to
                civilian life.
                <br />
                <br />
                WeVett Realty does this by connecting active-duty military with
                military specialized real estate agents who understand PCS moves
                and can help families seamlessly navigate the real estate
                transaction.
                <br />
                <br />
                WeVett Home Loans is a VA specialized lender that offers quick
                closes, high-quality communication, and long-term real estate
                expertise for military families around the country.
                <br />
                <br />
                We are ready to take our mission to the next level - and are
                looking for someone to forge new paths with us as we expand our
                mission to a larger global audience.
              </p>
            </div>
            <div>
              <h3>The Position:</h3>
              <p>
                Are you someone who thrives on communicating with other people -
                whether that be in person, through the written word or via
                digital channels? Does being a key part of a highly-focused,
                mission-driven company excite and motivate you? Are you an
                out-of-the-box thinker who loves to brainstorm new ideas for
                growth and see them through to completion?
                <br />
                <br />
                Then this position might be for you.
                <br />
                <br />
                We are looking for a Marketing Coordinator that is versatile and
                proficient in a variety of skills including social media
                management, content creation, email writing, and more.
                <br />
                <br />
                This individual needs to have an excellent grasp of how to
                effectively communicate via marketing efforts to our active duty
                military audience.
              </p>
            </div>
            <div>
              <h3>Winning Attributes</h3>
              <p>
                A successful, thriving Marketing Coordinator will possess the
                following attributes:
                <ul>
                  <li>Creative, out-of-the-box thinker</li>
                  <li>Excellent communication skills</li>
                  <li>Strong organizational skills</li>
                  <li>
                    Comprehensive understanding of social media strategy and
                    management
                  </li>
                  <li>
                    Self-learner that can come to the table with new ideas
                  </li>
                  <li>Able to take a project from concept to completion</li>
                  <li>
                    Adaptable and capable of taking on a variety of marketing
                    functions
                  </li>
                  <li>Basic Graphic Design Skills</li>
                  <li>
                    Understand military audiences and generate content that
                    speaks to their needs
                  </li>
                  <li>
                    Ability to take mortgage and real estate concepts and
                    communicate them to an outside audience
                  </li>
                </ul>
              </p>
            </div>
            <div>
              <h3>What you will be doing</h3>
              <p>
                <ul>
                  <li>
                    Work with Marketing Director to build content calendar and
                    outline distribution initiatives
                  </li>
                  <li>
                    Tackle all written communications for the WeVett brands,
                    including but not limited to, email writing, blog editing
                    and publishing, whitepaper and guide development, website
                    content, physical mailer campaigns and more
                  </li>
                  <li>
                    Manage brand social media accounts, including LinkedIn,
                    Facebook, Instagram, YouTube, TikTok and more
                  </li>
                  <li>
                    Monitor the military, mortgage and real estate world for
                    relevant opportunities to showcase the WeVett brand and
                    develop relationships with related businesses and
                    influencers
                  </li>
                  <li>
                    Develop strong relationships within the military community
                    and creatively engage with military members and spouses via
                    a variety of online channels
                  </li>
                </ul>
              </p>
            </div>
            <div>
              <h3>What we need from you</h3>
              <p>
                <i>Must Have Qualifications:</i>
                <ul>
                  <li>
                    Associates degree or higher, and/or certifications in
                    marketing or communications related fields
                  </li>
                  <li>The desire to serve military members</li>
                  <li>Strong communication skills (written and verbal)</li>
                  <li>Self-motivated and proactive with strong work ethic</li>
                  <li>
                    Proficient in computer technologies ie. navigating website
                    blog software, marketing email systems, social media
                    platforms, Google Suite, etc.
                  </li>
                </ul>
              </p>
              <p>
                <i>Nice to Have Qualifications:</i>
                <ul>
                  <li>Current military spouse</li>
                  <li>Prior military (or military spouse) experience</li>
                  <li>
                    12+ months experience in marketing, social media management,
                    or communications role
                  </li>
                </ul>
              </p>
            </div>
            <div>
              <h3>The Place & The People</h3>
              <p>
                Ready to join a talented team who is making the dream of home
                ownership possible for more of our military members? Welcome to
                WeVett, where our workplace atmosphere is alive with energy,
                creativity and a thirst for excellence.
                <br />
                <br />
                <strong>To Pursue Meaningful Connection Daily</strong> is one of{" "}
                <Link to={`/about`}>our four Core Values,</Link> and it is at
                the very heart of how we treat each other, our clients and our
                community. Whether it’s providing elite client service or
                continuously striving to improve, our Core Values provide a
                pathway to a more successful personal and professional life.
                <br />
                <br />
                From the team member that holds a door open to the one that
                helps guide your career, you’ll feel the encouragement and
                support on day one. We can’t wait to watch you succeed!
              </p>
            </div>
          </div>
          <div className={classNames("section", "disclaimer")}>
            <h2>Disclaimer</h2>
            <p>
              All the above duties and responsibilities are essential job
              functions subject to reasonable accommodation and change.
              <br />
              All job requirements listed indicate the minimum level of
              knowledge, skills and/or ability deemed necessary to perform the
              job proficiently.
              <br />
              Team members may be required to perform other or different
              job-related duties as requested by their team lead, subject to
              reasonable accommodation. This document does not create an
              employment contract, implied or otherwise.
              <br />
              WeVett Realty
              <br />
              KREC CO00003195 Equal Opportunity Employer
            </p>
          </div>
        </div>
      </div>
      <CustomFooter />
    </div>
  );
};

export default MarketingCoordinator;
